const store = {
    namespaced: true,
    state() {
        return {
            isLoadPartition: true,
            isLoad: true,
            categories: [],
            partition: [],
            filters: [],
            grinding: [],
            selectedFilters: [],
            currentGoods: {
                id: 0,
                imagePath: '',
                goods: [],
                hasGrinding: false
            },
            news: [],
            activeCategory: null,
            activeSort: null
        };
    },
    getters: {
        products(state) {
            return state.categories.reduce((accumulator, category) => {
                category.goodscard.forEach(product => {
                    if (!accumulator.find(item => item.id === product.id)) {
                        accumulator.push(product);
                    }
                });
                return accumulator;
            }, []);
        },
        getCategories(state) {
            return state.categories;
        },
        getActiveCategory(state) {
            return state.activeCategory;
        },
        getActiveSort(state) {
            return state.activeSort;
        },
        getIsLoad(state) {
            return state.isLoad;
        },
        getIsLoadPartition(state) {
            return state.isLoadPartition;
        }
    },
    mutations: {
        setIsLoad(state, flag) {
            state.isLoad = flag;
        },
        setIsLoadPartition(state, flag) {
            state.isLoadPartition = flag;
        },
        setCategories(state, data) {
            state.categories = data;
        },
        setPartition(state, data) {
            state.partition = data;
        },
        setFilters(state, data) {
            state.filters = data;
        },
        setGrinding(state, data) {
            state.grinding = data;
        },
        setSelectedFilters(state, data) {
            state.selectedFilters = data;
        },
        setCurrentGoods(state, data) {
            state.currentGoods = data;
        },
        setNews(state, data) {
            state.news = data;
        },
        setActiveCategory(state, data) {
            state.activeCategory = data;
        },
        setActiveSort(state, data) {
            state.activeSort = data;
        }
    },
    actions: {
        getProducts({ commit }, data) {
            commit('setIsLoad', true);
            return this.$axios
                .get(`general/v2/category/${data?.slug}/`, {
                    params: data?.params,
                    headers: {
                        'Accept-Language': this?.$i18n?.locale
                    }
                })
                .then(response => {
                    commit('setCategories', response.data);
                    commit(
                        'setFilters',
                        response.data?.filters?.optionsValues?.map(item => {
                            return {
                                ...item,
                                options: item.options.map(element => {
                                    return {
                                        ...element,
                                        filterspkey: item.sp_key
                                    };
                                })
                            };
                        }) || []
                    );
                    setTimeout(() => {
                        commit('setIsLoad', false);
                    }, 100);

                    return response.data;
                });
        },
        getPartition({ commit }) {
            commit('setIsLoadPartition', true);
            return this.$axios.get('general/menu_tree').then(response => {
                commit('setPartition', response.data);

                setTimeout(() => {
                    commit('setIsLoadPartition', false);
                }, 100);
                return response.data;
            });
        },
        getFilters({ commit }) {
            return this.$axios.get('/api/v1/filter').then(response => {
                commit('setFilters', response.data);
                return response.data;
            });
        },
        getGrinding({ commit }) {
            return this.$axios.get('/api/v1/grinding').then(response => {
                commit('setGrinding', response.data);
                return response.data;
            });
        },
        getProduct({ commit }, chpu) {
            return this.$axios.get(`/general/v2/product/${chpu}/`).then(response => response.data);
        },
        getNews({ commit }) {
            return this.$axios.get('base/articles').then(response => {
                commit('setNews', response.data.data);
                return response.data.data;
            });
        },
        getNewsItem({ commit }, chpu) {
            return this.$axios.get(`/api/v1/news/${chpu}`).then(response => response.data);
        }
    }
};

export default store;
